module.exports = __webpack_public_path__ + "img/10.c0d8729e.jpg";